var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeOff = function SvgEyeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.12 16.12a3 3 0 1 1-4.24-4.24M3 3l22 22m-5.06-5.06A10.07 10.07 0 0 1 14 22c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94l11.88 11.88ZM11.9 6.24A9.12 9.12 0 0 1 14 6c7 0 11 8 11 8a18.498 18.498 0 0 1-2.16 3.19L11.9 6.24Z",
    stroke: "#4FAA9F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEyeOff;